import React, { useEffect, useState } from 'react';
const NAMES = ['Martín', 'Diego', 'Facundo', 'Nicolás', 'Alejandro', 'Pablo', 'Federico', 'Tomás', 'Joaquín', 'Santiago', 'Emiliano', 'Agustín', 'Ramiro', 'Leandro', 'Damián'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'Paraná'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showPopup = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setCurrentName(randomName);
    setCurrentCity(randomCity);
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup (15-20 seconds later)
      const nextDelay = Math.floor(Math.random() * 5000) + 15000;
      setTimeout(() => {
        showPopup();
      }, nextDelay);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-2xl border border-gray-200 p-4 max-w-sm animate-in slide-in-from-bottom-5 fade-in duration-300 flex items-center gap-4" data-id="element-231">
      <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-232">
        <span className="text-xl" data-id="element-233">✅</span>
      </div>
      <div data-id="element-234">
        <p className="text-sm text-gray-800 font-medium" data-id="element-235">
          <span className="font-bold" data-id="element-236">{currentName}</span> de{' '}
          <span className="font-bold" data-id="element-237">{currentCity}</span>
        </p>
        <p className="text-xs text-gray-500 mt-0.5" data-id="element-238">
          acaba de comprar el MegaPack
        </p>
      </div>
    </div>;
}